import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ModalConfirmationData {
  message: string;
  alertType: 'success' | 'warning' | 'error' | 'info';
  showCancel: boolean;
  showConfirm: boolean;
}

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss'],
})
export class ModalConfirmationComponent {
  message: string;
  alertType: string;
  showCancel: boolean;
  showConfirm: boolean;
  backgroundColor: string;

  constructor(
    private dialogRef: MatDialogRef<ModalConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalConfirmationData,
  ) {
    this.message = data.message;
    this.alertType = data.alertType;
    this.showCancel = data.showCancel;
    this.showConfirm = data.showConfirm;

    // Definir cor de fundo com base no tipo de alerta
    switch (this.alertType) {
      case 'success':
        this.backgroundColor = '#8DC881';
        break;
      case 'warning':
        this.backgroundColor = 'orange';
        break;
      case 'error':
        this.backgroundColor = 'red';
        break;
      case 'info':
      default:
        this.backgroundColor = 'blue';
        break;
    }
  }

  get htmlSafeMessage(): string {
    return this.message.replace(/\n/g, '<br>');
  }

  close() {
    this.dialogRef.close('closed');
  }

  confirm() {
    this.dialogRef.close('confirmed');
  }
}
